/**
 * Throw new expection with error message.
 *
 * @param {*} errorMessage
 *
 * @throws {Error}
 */
export const exception = (errorMessage) => {
    throw new Error(errorMessage);
};
